import { z } from 'zod';

import { ProductType } from '../graphql';

// Mapping from URL path strings to ProductType enum values
const PATH_TO_PRODUCT_TYPE: Record<string, ProductType> = {
  rd: ProductType.UsRd,
  asc: ProductType.UsAsc,
  sred: ProductType.CaSred,
};

export const PRODUCT_OPTIONS: { value: ProductType; label: string }[] = [
  { value: ProductType.UsRd, label: 'R&D Tax Credit' },
  { value: ProductType.UsAsc, label: 'ASC 350-40' },
  { value: ProductType.CaSred, label: 'SR&ED Tax Credit' },
];

// Schema that validates path strings and transforms them to ProductType
export const ProductPathSchema = z
  .enum(Object.keys(PATH_TO_PRODUCT_TYPE) as [string, ...string[]])
  .transform((path) => PATH_TO_PRODUCT_TYPE[path]);

// Schema that validates ProductType enum values directly (used for localStorage)
export const ProductTypeSchema = z.nativeEnum(ProductType);

// Helper function to convert path string to ProductType
export const pathToProductType = (path: string): ProductType | null => PATH_TO_PRODUCT_TYPE[path] ?? null;

export const productDisplayName = (product: ProductType): string =>
  PRODUCT_OPTIONS.find(({ value }) => value === product)?.label ?? '';
